import React, { PropTypes } from 'react';
import InputGroup from '../InputGroup';
import BaseField from './Base';


export default class TextAreaField extends BaseField {
  static propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string,
    group: PropTypes.shape({})
  };

  render() {
    const { id } = this.state;
    const {
      group,
      label,
      placeholder,
      input,
      meta: { touched,  error, invalid }
    } = this.props;

    return (
      <InputGroup id={id} invalid={touched && invalid} label={label} {...group}>
        <textarea {...input} id={id} placeholder={placeholder} className="form-control" />
        { (touched && error) && <div className="form-control-feedback">{error}</div> }
      </InputGroup>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Form/Field/TextArea.js